// extracted by mini-css-extract-plugin
module.exports = {"primaryCTA":"Mw","disabled":"Nw","secondaryCTA":"Ow","disabledCTA":"Pw","notified":"Qw","remove":"Rw","dimensions":"Sw"};